import BackLink from "@/components/BackLink";

export default function Riktlinjer() {
  return (
    <div data-testid="riktlinjer-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <BackLink to="/om-oss" label="Om oss" />

      <h1 className="font-heading text-3xl sm:text-4xl font-medium text-ink mb-3">Riktlinjer</h1>
      <p className="text-lg text-muted-foreground mb-10 max-w-2xl leading-relaxed">
        vidalv.live ska vara en trygg och trevlig plats. Dessa enkla regler gäller för allt som publiceras.
      </p>

      <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8">
        <div className="flex flex-col gap-6 text-base text-ink leading-relaxed">
          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Var hederlig</h2>
            <p>Skriv bara sådant som stämmer. Beskriv saker och tjänster ärligt. Om du säljer något, ange skicket som det verkligen är.</p>
          </div>

          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Var tydlig</h2>
            <p>Skriv så att andra förstår vad du menar. Ange vad du erbjuder eller söker, var du befinner dig och hur man når dig.</p>
          </div>

          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Var respektfull</h2>
            <p>Alla ska känna sig välkomna oavsett bakgrund, ålder eller hur länge man bott i bygden. Inga kränkningar, inget hat, ingen diskriminering.</p>
          </div>

          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Håll det lokalt</h2>
            <p>vidalv.live är till för Backe, Rossön och bygderna däremellan. Anslag som inte har lokal anknytning kan avvisas.</p>
          </div>

          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Moderering</h2>
            <p>Alla anslag granskas av vårt lokala team innan de publiceras. Vi förbehåller oss rätten att redigera eller avvisa anslag som inte följer riktlinjerna. Vid frågor kontaktar vi dig via den kontaktväg du angett.</p>
          </div>

          <div>
            <h2 className="font-heading text-lg font-medium text-ink mb-2">Kontaktuppgifter</h2>
            <p>De kontaktuppgifter du anger i ditt anslag visas publikt så att intresserade kan nå dig. Ange bara det du är bekväm med att visa.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
